import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Remove HTML comments from all levels of the DOM
function purgeComments() {
  // Check document-level nodes (outside <html>)
  document.childNodes.forEach(node => {
    if (node.nodeType === 8) node.remove();
  });
  // Check <html> direct children
  document.documentElement.childNodes.forEach(node => {
    if (node.nodeType === 8) node.remove();
  });
  // Check <head>
  document.head.childNodes.forEach(node => {
    if (node.nodeType === 8) node.remove();
  });
  // Check <body>
  document.body.childNodes.forEach(node => {
    if (node.nodeType === 8) node.remove();
  });
  // Deep walk everything
  const walker = document.createTreeWalker(document.documentElement, NodeFilter.SHOW_COMMENT);
  const toRemove: Node[] = [];
  while (walker.nextNode()) toRemove.push(walker.currentNode);
  toRemove.forEach(n => n.parentNode?.removeChild(n));
}
// Run immediately
purgeComments();
// Watch for any new comments being injected
new MutationObserver(() => purgeComments()).observe(document, {
  childList: true,
  subtree: true
});
// Run on multiple ticks
requestAnimationFrame(purgeComments);
setTimeout(purgeComments, 0);
setTimeout(purgeComments, 50);
setTimeout(purgeComments, 200);
setTimeout(purgeComments, 1000);
setTimeout(purgeComments, 3000);
render(<App data-id="element-252" />, document.getElementById('root'));